import * as prodTypes from '../actionTypes';
const initialState = {
    loading: false,
    brands: [],
    brandItems: [],
    catProducts: [],
    brandInView: {},
    productInView: {},
    loadingProduct: false,
};
export const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case prodTypes.GET_PRODUCTS:
            return { ...state, loading: true };
        case prodTypes.GET_PRODUCTS_SUCCESS:
            return { ...state, loading: false, products: action.payload };
        case prodTypes.GET_PRODUCTS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_PRODUCTS_BY_CATEGORY:
            return { ...state, loading: true };
        case prodTypes.GET_PRODUCTS_BY_CATEGORY_SUCCESS:
            return { ...state, loading: false, productsByCategory: action.payload };
        case prodTypes.GET_PRODUCTS_BY_CATEGORY_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_CATEGORIES:
            return { ...state, loading: true };
        case prodTypes.GET_CATEGORIES_SUCCESS:
            return { ...state, loading: false, categories: action.payload };
        case prodTypes.GET_CATEGORIES_FAIL:
            return { ...state, loading: false, error: action.payload };
        case prodTypes.GET_CATEGORY_DETAILS:
            return { ...state, loading: true };
        case prodTypes.GET_CATEGORY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                catProducts: action.payload,
            };
        case prodTypes.GET_CATEGORY_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case prodTypes.CREATE_CART:
            return { ...state, loading: true };
        case prodTypes.CREATE_CART_SUCCESS:
            return { ...state, loading: false, quoteId: action.payload };
        case prodTypes.CREATE_CART_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.ADD_TO_CART:
            return { ...state, adding: true };
        case prodTypes.ADD_TO_CART_SUCCESS:
            return { ...state, adding: false, cart: action.payload };
        case prodTypes.ADD_TO_CART_FAIL:
            return { ...state, adding: false, error: action.payload };
        case prodTypes.ADD_TO_CART_CANCEL:
            return { ...state, adding: false };

        case prodTypes.CHECKOUT_CART:
            return {
                ...state,
                checkoutLoading: true,
                checkoutResult: null,
            };

        case prodTypes.CHECKOUT_CART_SUCCESS:
            return { ...state, checkoutLoading: false, checkoutResult: action.payload };
        case prodTypes.CHECKOUT_CART_FAIL:
            return { ...state, checkoutLoading: false, checkoutResult: action.payload };

        case prodTypes.UPDATE_CART:
            return { ...state, updating: true };
        case prodTypes.UPDATE_CART_SUCCESS:
            return { ...state, updating: false, cart: action.payload };
        case prodTypes.UPDATE_CART_FAIL:
            return { ...state, updating: false, error: action.payload };

        case prodTypes.REMOVE_FROM_CART:
            return { ...state, removing: true };
        case prodTypes.REMOVE_FROM_CART_SUCCESS:
            return { ...state, removing: false, cart: action.payload };
        case prodTypes.REMOVE_FROM_CART_FAIL:
            return { ...state, removing: false, error: action.payload };

        case prodTypes.VIEW_CART_DETAILS:
            return { ...state, loading: true };
        case prodTypes.VIEW_CART_DETAILS_SUCCESS:
            return { ...state, loading: false, cartItems: action.payload };
        case prodTypes.VIEW_CART_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case prodTypes.LOGOUT:
            return {};

        case prodTypes.ADD_SHIPPING_DETAILS:
            return { ...state, loading: true };
        case prodTypes.ADD_SHIPPING_DETAILS_SUCCESS:
            return { ...state, loading: false, details: action.payload };
        case prodTypes.ADD_SHIPPING_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_SHIPPING_DETAILS:
            return { ...state, loading: true };
        case prodTypes.GET_SHIPPING_DETAILS_SUCCESS:
            return { ...state, loading: false, details: action.payload };
        case prodTypes.GET_SHIPPING_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_CART_DETAILS:
            return { ...state, loading: true };
        case prodTypes.GET_CART_DETAILS_SUCCESS:
            return { ...state, loading: false, details: action.payload };
        case prodTypes.GET_CART_DETAILS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.ADD_BILLING_ADDRESS:
            return { ...state, loading: true };
        case prodTypes.ADD_BILLING_ADDRESS_SUCCESS:
            return { ...state, loading: false, billing_address: action.payload };
        case prodTypes.ADD_BILLING_ADDRESS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.PLACE_ORDER:
            return { ...state, loading: true };
        case prodTypes.PLACE_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                order_details: action.payload,
                quoteId: null,
                cartItems: null,
            };
        case prodTypes.PLACE_ORDER_FAIL:
            return { ...state, loading: false, error: action.payload };

        case prodTypes.GET_PRODUCT_STOCK:
            return { ...state, loading: true };
        case prodTypes.GET_PRODUCT_STOCK_SUCCESS:
            return {
                ...state,
                loading: false,
                productStock: action.payload,
            };
        case prodTypes.GET_PRODUCT_STOCK_FAIL:
            return { ...state, loading: false, error: action.payload };
        case prodTypes.FETCH_BRANDS:
            return { ...state, brands: action.payload };
        case prodTypes.LOADING_BRANDS:
            return { ...state, loading: action.payload };
        case prodTypes.FETCH_BRAND:
            return { ...state, brandItems: action.payload };
        case prodTypes.SELECT_BRAND:
            return { ...state, brandInView: action.payload };
        case prodTypes.SELECT_VENDOR:
            return { ...state, vendorInView: action.payload };
        case prodTypes.GET_PRODUCT:
            return { ...state, productInView: action.payload };
        case prodTypes.LOADING_PRODUCT:
            return { ...state, loadingProduct: action.payload };

        default:
            return state;
    }
};
